import { Typography } from "@mui/material";

export default function Policy(props) {
    return(
        <Typography variant="body1">
            Vous vous apprêtez à enregistrer un bordereau de versement.<br/>Vous pouvez enregistrer des versements à destination de la FEAM, la banque de la FEAM, la banque de votre église si elle en possède une et votre petite-caisse.
            Vous ne pouvez pas effectuer de versement pour la FEAM qui soit inférieur à la part des recettes qui lui revient.
        </Typography>
    )
}